import { cn } from '@/lib/utils';
import { MESSAGES } from '@/lib/messages';

type SpinnerProps = {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
};

const sizeMap = {
  sm: 'h-3.5 w-3.5 border-2',
  md: 'h-5 w-5 border-2',
  lg: 'h-8 w-8 border-[3px]',
};

export const Spinner = ({ size = 'md', className, label }: SpinnerProps) => (
  <span
    role="status"
    aria-label={label || MESSAGES.common.loading}
    className={cn(
      'inline-block animate-spin rounded-full border-current border-r-transparent text-burgundy-600',
      sizeMap[size],
      className
    )}
  />
);

type SpinnerOverlayProps = {
  label?: string;
  className?: string;
};

export const SpinnerOverlay = ({ label, className }: SpinnerOverlayProps) => (
  <div
    className={cn(
      'flex h-full min-h-[160px] w-full flex-col items-center justify-center gap-3 p-8 text-fg-subtle',
      className
    )}
  >
    <Spinner size="lg" />
    {label && <p className="text-sm">{label}</p>}
  </div>
);
